import * as React from 'react';
import Button from 'material-ui/Button';
import AddIcon from 'material-ui-icons/Add';

export interface OwnProps {
  onClick: (target: HTMLInputElement) => any;
}

export default (props: OwnProps) => {
  const { onClick } = props;

  return (
    <Button
      variant={'fab'}
      style={{
        backgroundColor: '#e1f694',
        position: 'fixed',
        right: 64,
        bottom: 64,
      }}
      onClick={onClick}
    >
      <AddIcon style={{ color: '#253238' }} />
    </Button>
  );
};



// WEBPACK FOOTER //
// ./src/components/FabButton/index.tsx